import { Link } from "react-router-dom";

export const Logo = ({ dark = false, className = "", imgClassName = "" }) => (
  <Link to="/" data-testid="logo-link" className={`inline-flex shrink-0 items-center ${className}`}>
    <img
      src={dark ? "/logo-pivot-white.png" : "/logo-pivot-color.png"}
      alt="Big Pivot Partners"
      className={`shrink-0 ${imgClassName || (dark ? "h-14 w-auto" : "h-12 md:h-14 w-auto")}`}
    />
  </Link>
);
